export const OC_CUSTOM_PRODUCTS = {
  desktop: `<div class="cui cui-grid -spacing--top-64 -spacing--bottom-48">
  <div class="cui-container -gap--v-40">
    <div class="cui-row">
      <div class="cui-col-md-1">
        <div class="cui-skeleton-paragraph -size--medium -resolution--desktop">
          <div class="cui-skeleton-paragraph__content" style="width: 100%;">
            <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="cui-row">
      <div class="cui-col-md-5">
        <div class="cui-skeleton-heading -size--large -spacing--bottom-32 -resolution--desktop">
          <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
            <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="cui-row -gap--h-40">
      <div class="cui-col-md-2">
        <div class="cui-container -gap--v-16">
          <div class="cui-row -spacing--bottom-40">
            <div class="cui-col">
              <div class="cui-skeleton-input -size--medium">
                <div class="cui-skeleton-input__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton-input__field"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="cui-row">
            <div class="cui-col">
              <div class="cui-skeleton-paragraph -size--medium -resolution--desktop">
                <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cui-col-md-6">
        <div class="cui-container -gap--v-24">
          <div class="cui-row">
            <div class="cui-col-md-1">
              <div class="cui-skeleton-paragraph -size--medium -resolution--desktop">
                <div class="cui-skeleton-paragraph__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton__description"></div>
                </div>
              </div>
            </div>
            <div class="cui-col-md-1 col-offset-md-6">
              <div class="cui-skeleton-button -size--medium">
                <div class="cui-skeleton-button__content" style="width: 100%;">
                  <div class="cui-skeleton__item cui-skeleton-button__button"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-64 -spacing--top-24">
            <div class="cui-skeleton__item" style="width: 100%; height: 128px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-64">
            <div class="cui-skeleton__item" style="width: 100%; height: 128px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-64">
            <div class="cui-skeleton__item" style="width: 100%; height: 128px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-64">
            <div class="cui-skeleton__item" style="width: 100%; height: 128px"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`
};
